import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { media } from '~layout';
var FeatureContainer = styled.article.withConfig({
  displayName: "FeatureContainer",
  componentId: "sc-1ysrwdu-0"
})(["padding-bottom:", "vh;padding-top:", "vh;", ""], function (_ref) {
  var verticalSpacing = _ref.verticalSpacing;
  return verticalSpacing / 2;
}, function (_ref2) {
  var verticalSpacing = _ref2.verticalSpacing;
  return verticalSpacing / 2;
}, media.sm(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        padding-bottom: ", "vh;\n        padding-top: ", "vh;\n    "])), function (_ref3) {
  var verticalSpacing = _ref3.verticalSpacing;
  return verticalSpacing;
}, function (_ref4) {
  var verticalSpacing = _ref4.verticalSpacing;
  return verticalSpacing;
}));
export default FeatureContainer;